import * as helpers from "./lightbox_helpers";
import { decodeUtf8 } from "base/backbone/lib/utilities/helpers";
import { LightBoxEvents } from "./lightbox_events.js";
import { PixleeCTACarousel } from "./lightbox_carousel";
import { PixleeHotspots } from "./lightbox_hotspots";
import { PixleeReviews } from "./lightbox_reviews"

export var isLightboxOpen = false;
export var PixleeCarousel;
export var HotspotsHelper;
export var ReviewsHelper;

export function setLightboxOpen(data) {
    isLightboxOpen = data;
}

$(function() {
    var data = [];
    var spinnerUrl;
    $.extend(true, I18n.translations[I18n.locale], gon.custom_text);
    var _api = {
        onSetCtaLinks: function(template, data, currentAlbum, displayOptions) {
            helpers.setOrReplaceCtaLinks(template, data, currentAlbum, displayOptions);
        }
    };

    var isTablet = gon.isTablet;
    var isMobile = gon.isMobile;
    var isDesktop = gon.isDesktop;

    var deviceName = 'desktop';
    if (isTablet) {
        deviceName = 'tablet';
    } else if (isMobile) {
        deviceName = 'mobile';
    }

    if (!isDesktop) {
        // Need to keep track when pageshow is executed because it needs to be executed first
        // before we update albumPhotoId saved in localStorage
        var checkedPixleePersisted = false;

        // If the lightbox is visited by pressing the back/forward button (if the page is persisted), the iframe's
        // needs to be refreshed for JS events to bind properly and for the correct
        // lightbox content to show up with the last viewed pixlee_album_photo_id
        $(window).bind('pageshow.pixleePersisted', function(event) {
            var pagePersisted = false;
            if (window.performance) {
                var apiLv2Persisted = false;
                if (window.performance.getEntriesByType) {
                    var navEntries = window.performance.getEntriesByType('navigation');
                    apiLv2Persisted = navEntries.length > 0 && navEntries[0].type === 'back_forward';
                }
                var apiLv1Persisted = window.performance.navigation &&
                    window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD;
                pagePersisted = apiLv2Persisted || apiLv1Persisted;
            }
            if (pagePersisted || event.originalEvent.persisted) {
                var pixleeAlbumPhotoId = window.localStorage ? window.localStorage.getItem('pixleeAlbumPhotoId') : null;
                var data = {
                    name: 'pixlee:page:persisted',
                    type: 'action',
                    destination: 'all',
                    source: '',
                    data: {
                        pixleeAlbumPhotoId: pixleeAlbumPhotoId
                    }
                };
                window.parent.postMessage(JSON.stringify(data), '*');
            }
            checkedPixleePersisted = true;
        });

    }

    function openLightbox(index, currentAlbum, displayOptions, pageSize) {
        // Falls to gon variables to enable shared links
        if (_.isFalsy(currentAlbum)) {
            currentAlbum = gon.current_album;
            displayOptions = gon.display_options;
        }

        spinnerUrl = helpers.getSpinnerUrl(displayOptions);
        helpers.determineLightboxVersion(displayOptions);


        var _this = globalThis;

        var markup = require('./templates/' + helpers.lightboxVersion + '/' + deviceName + '.jst.ejs');
        isLightboxOpen = false;


        helpers.setEnableReviews(displayOptions.reviewOptions && displayOptions.reviewOptions.lightboxReviews);
        if (helpers.enableLightboxReviews) {
            ReviewsHelper = new PixleeReviews();
            if (isDesktop) {
                ReviewsHelper.setVisibility(true);
            }
        }

        if (!isDesktop) {
            if (helpers.lightboxVersion === 'v2') {
                helpers.setEnableCarousel(true);
                PixleeCarousel = new PixleeCTACarousel('#cta_container', isMobile);
            }
        }

        if (displayOptions.hotspots) {
            HotspotsHelper = new PixleeHotspots('#' + deviceName + '_hotspot_holder');
        }

        function setLightboxOptions(displayOptions) {
            if (!isMobile) {
                if (displayOptions.disablePoweredByClick) {
                    $('#powered_by_pixlee').css('pointer-events', 'none');
                }
            }
            if (displayOptions.lightboxOptions) {
                var reportHref = displayOptions.lightboxOptions.customReportHref;
                if (_.isTruthy(reportHref)) {
                    if (isMobile) {
                        $('#mobile_report_button').attr('href', reportHref);
                    } else {
                        $('#report_button').attr('href', reportHref);
                    }
                }
            }
        }

        function initializeVideo(videoSettings, videoPlayerOptions) {
            _this.videoPlayer = videojs('pixlee_video');
            _this.videoPlayer.videoSettings = videoSettings;
            _this.videoPlayer.videoPlayerOptions = videoPlayerOptions;
            if (!isDesktop) {
                _this.videoPlayer.ready(function() {
                    if (isTablet) {
                        var htmlPlayer = $('#pixlee_video_html5_api');
                        var thumbnailUrl = htmlPlayer.attr('thumbnail');
                        htmlPlayer.attr('poster', thumbnailUrl);
                    }
                    $('.vjs-poster').hide();
                });
            }
            _this.videoPlayer.on('loadedmetadata', function() {
                if (!isDesktop) {
                    this.firstPlay = true;
                    this.currentTime(0.01);
                }

                if (this.videoSettings.start > 0) {
                    // Fix for mobile/tablet to scrub to start the vdieo at the right time
                    if (!isDesktop) {
                        this.on('play', function() {
                            if (this.firstPlay) {
                                this.currentTime(this.videoSettings.start);
                            }
                            this.firstPlay = false;
                        });
                    } else {
                        this.currentTime(this.videoSettings.start);
                    }
                } else if (isDesktop && !this.videoPlayerOptions.autoplay) {
                    // Prevents loader from showing when autoplay is off
                    this.currentTime(0.01);
                }

                //disable sound completely
                if (displayOptions.muteVideos) {
                    this.volume(0);
                }

                if (isDesktop || isMobile) {
                    this.dimensions(620, 620);
                }

                if (!this.videoPlayerOptions.sound) {
                    this.muted(true); // mute to start
                }

                if (this.videoPlayerOptions.autoplay) {
                    this.play();
                }

                if (this.videoPlayerOptions.loop) {
                    this.loop(true);
                }

                if (this.videoSettings.start > 0 || this.videoSettings.end > 0) {
                    this.on('timeupdate', function(_e) {
                        var videoDuration = this.videoSettings.end > 0 ? this.videoSettings.end : this.duration();
                        if (this.currentTime() >= videoDuration) {
                            this.currentTime(this.videoSettings.start || 0);
                            if (!this.videoPlayerOptions.loop) {
                                this.pause();
                            }
                        }
                    });
                }

                if (!isDesktop) {
                    // Don't show videojs custom play bar on mobile/tablet
                    $('.vjs-control-bar').hide();
                }

                //direct links to videos make magnificpopup think there is an error. undo what it does
                $('.mfp-s-error').removeClass('mfp-s-error');
                $('.dead_image').remove();
                $('.mfp-preloader').hide();
            });

            if (!isDesktop) {
                if (helpers.enableCarousel) {
                    PixleeCarousel.initialize();
                }
            }
            _this.videoPlayer.load();
        }


        var mfpOptions = {
            items: data,
            key: 'my-popup',
            type: 'image',
            image: {
                // Define markup. Class names should match key names.
                markup: markup(),
                verticalFit: false
            },
            closeMarkup: '<button type="button" class="mfp-close">' + I18n.t('common.controls.close') + '</button>',
            tLoading: '',
            gallery: {
                enabled: true,
                preload: [0, 4],
                tPrev: I18n.t('common.controls.previous'),
                tNext: I18n.t('common.controls.next')
            },
            callbacks: {
                open: function() {
                    // Accessiblity fix for iOS/VoiceOver: https://github.com/pixlee/photos/pull/1837
                    if (isMobile) {
                        $('.mfp-content').attr({
                            role: 'dialog',
                            'aria-modal': 'true',
                            'aria-label': I18n.t('lightbox.screen_reader_only.title'),
                            'aria-description': I18n.t('lightbox.screen_reader_only.description')
                        });
                    }
                    if (isMobile) {
                        var ua = navigator.userAgent;
                        var isNativeAndroid = ((ua.indexOf('Mozilla/5.0') > -1 && ua.indexOf('Android ') > -1 && ua.indexOf('AppleWebKit') > -1) && (ua.indexOf('Version') > -1));
                        if (isNativeAndroid) {
                            $('.mfp-content').addClass('mfp-android-stock');
                        }
                    }
                    if (!isDesktop) {
                        var leftArrow = $('.mfp-arrow-left');
                        var rightArrow = $('.mfp-arrow-right');

                        if (isMobile) {
                            leftArrow.addClass('mobile_arrow');
                            rightArrow.addClass('mobile_arrow');
                        } else {
                            leftArrow.addClass('tablet_arrow');
                            rightArrow.addClass('tablet_arrow');
                        }
                    }
                    var data = {
                        name: 'pixlee:show:lightbox',
                        type: 'action',
                        source: 'lightbox',
                        destination: 'parent',
                        data: {}
                    };

                    // reset body classes that determine focus styles
                    helpers.removeBodyClass('using-keyboard');
                    helpers.removeBodyClass('using-mouse');

                    // since ev.type === 'keydown' returns false in openPhotoLightbox and openVideoLightbox
                    // gon.usingKeyboard will be false if lightbox is visited directly
                    if (gon.usingKeyboard) {
                        document.body.classList.add('using-keyboard');
                    } else {
                        document.body.classList.add('using-mouse');
                    }

                    // contains the event listeners for applying focus styles
                    helpers.toggleUserNavigationClass(document.body);

                    helpers.initLightboxFocus();
                    window.parent.postMessage(JSON.stringify(data), '*');
                    helpers.initializeClicks();
                    isLightboxOpen = true;
                    helpers.modifyPBPDestination();
                    setLightboxOptions(gon.display_options);

                    if (!isDesktop) {
                        var target = document.getElementById(isTablet ? 'top_panel' : 'image_holder');

                        if (_this.hammertime) {
                            _this.hammertime.destroy();
                        }

                        _this.hammertime = new Hammer(target);

                        _this.hammertime.on('swipe', function(ev) {
                            if (ev.direction === 2) {
                                rightArrow.click();
                            } else if (ev.direction === 4) {
                                leftArrow.click();
                            }

                        });

                        //Applies/removes TikTok specific styles on tablets and mobiles for TikTok content
                        var isTikTokContent = this.currItem.data.source === 'tiktok';
                        if (isTablet && isTikTokContent) {
                            helpers.applyTabletTiktokStyles();
                        } else if (isTablet) {
                            helpers.removeTabletTiktokStyles();
                        } else if (isTikTokContent) { //mobile condition && isTikTokContent
                            helpers.applyMobileTiktokStyles();
                        } else {
                            helpers.removeMobileTiktokStyles();
                        }
                    } else {
                        helpers.applyStyleBySource(this.currItem.data.source);
                    }
                },
                close: function() {
                    _this.prevIndex = undefined;

                    helpers.closeLightbox();
                    if (!isDesktop) {
                        _this.hammertime.off('swipe');
                        if (isMobile) {
                            if (helpers.enableHotspots) {
                                HotspotsHelper.destroyHammertime();
                            }
                        }

                        if (helpers.enableCarousel) {
                            PixleeCarousel.destroy();
                        }
                        // In cases window.localStorage is null (Firefox mobile)
                        if (window.localStorage) {
                            window.localStorage.removeItem('pixleeAlbumPhotoId');
                        }
                    }
                },
                imageLoadComplete: function() {
                    if (!isDesktop || !displayOptions.qrCodeCta) {
                        helpers.initializeCtaClicks(currentAlbum, displayOptions, isMobile);
                    }

                    if (!isDesktop) {
                        if (helpers.enableCarousel) {
                            PixleeCarousel.initialize();
                        }
                    }

                    if (helpers.enableHotspots) {
                        HotspotsHelper.renderHotspots();
                        if (isDesktop && !displayOptions.qrCodeCta) {
                            HotspotsHelper.setToggleVisibilityOnHover();
                            HotspotsHelper.setPeekActiveHotspotTrigger($('#cta_block'));
                        }

                        if (!isDesktop) {
                            HotspotsHelper.setToggleVisibilityOnTap();
                        }
                    }
                },
                updateStatus: helpers.onLightboxUpdateStatus,
                change: function(currentItem) {
                    if (_this.prevIndex !== undefined && isMobile) { // Not on first open, only on image change
                        if (helpers.hasMovedRight(_this.prevIndex, currentItem.index, this.items.length - 1)) {
                            setTimeout(function() {
                                $('.mfp-arrow-right').focus();
                            }, 0);
                        } else {
                            setTimeout(function() {

                                $('.mfp-arrow-left').focus();
                            }, 0);
                        }
                    }
                    _this.prevIndex = currentItem.index;
                    if (!isDesktop) {
                        // If Carousel is enabled, we want to make sure it's destroyed on every change, it will get created again when the CTAs get created
                        if (helpers.enableCarousel) {
                            PixleeCarousel.destroy();
                        }
                    }
                    //_this already refers to the view, need a new var name to refer to the magnific popup object
                    helpers.setMagnificPopupIndex(currentItem.index);

                    // .ariaLiveMessage is defined just under the body, in lightbox.html.erb
                    // We are doing this for acccessibility, so that the text reader will announce the
                    // new slide
                    $('.ariaLiveMessage')
                        .text(I18n.t('photo_item.aria_live_message',
                            { index: this.currItem.index + 1, total: this.items.length, alt_text: this.currItem.alt }));

                    if (_this.videoPlayer) {
                        _this.videoPlayer.pause();
                    }

                    var data = {
                        name: 'pixlee:change:lightbox:image',
                        type: 'action',
                        source: 'lightbox',
                        destination: 'parent',
                        data: {
                            id: this.currItem.data.album_photo_id ||
                                this.currItem.data.id,
                            //'change' always fires before 'open', so this will always be correctly set
                            initialOpen: !isLightboxOpen
                        }
                    };

                    window.parent.postMessage(JSON.stringify(data), '*');
                    if (this.currItem && this.currItem.data) {
                        var albumPhotoId = this.currItem.data.album_photo_id;
                        var currentPage = Math.ceil(
                            (1.0 * (this.index + 1)) / pageSize
                        );
                        var contentSource = this.currItem.data.source;
                        var contentType = this.currItem.data.content_type;
                        var reviewInfo =
                            this.currItem.data.selectedReviewInfo || null;

                        // checking if the piece of content clicked has a product badge shown, using isProductBadgeShown function from lightbox_helpers.js
                        var productBadge = !!helpers.isProductBadgeShown(this.currItem.data.products, displayOptions);

                        // it is a click if the lightbox change without being open
                        LightBoxEvents.OpenedPhoto(albumPhotoId, contentSource, contentType,
                            currentPage, !isLightboxOpen, reviewInfo, productBadge);

                        this.time = Date.now();
                        this.lastItem = albumPhotoId;

                        if (isDesktop) {
                            //if we had an active review tile, lets add a class to the lightbox
                            this.content.toggleClass('reviews_active', reviewInfo && reviewInfo.active);

                        } else {
                            //if we had an active review tile and lightbox reviews turned on, lets add a class to the lightbox
                            this.content.toggleClass('reviews_active', _.isTruthy(reviewInfo && reviewInfo.active && helpers.enableLightboxReviews));
                        }
                    }
                    helpers.linkLoaded(this.currItem.data);

                    if (!isDesktop) {

                        if (_.isTruthy(_this.videoPlayer)) {
                            _this.videoPlayer.src('');
                        }
                    }
                    var activeReview = !isDesktop && this.currItem.data.selectedReviewInfo && this.currItem.data.selectedReviewInfo.active;
                    var videoSettings = this.currItem.data.video_settings || {
                        start: undefined,
                        end: undefined,
                        thumbnail_name: undefined,
                        thumbnaile_url: undefined
                    };
                    var videoPlayerOptions = gon.display_options.videoOptions || {
                        autoplay: undefined,
                        loop: undefined,
                        sound: undefined
                    };

                    var dataSource = this.currItem.data.source;

                    // For Pixlee Uploaded Videos
                    var usesPlatformEmbed = _.contains(['tiktok', 'twitch', 'youtube'], dataSource);
                    if (this.currItem.data.content_type === 'video' && !usesPlatformEmbed && !activeReview) {
                        var videoURL = this.currItem.data.videoURL;
                        if (_this.videoPlayer) {
                            $('#pixlee_video_html5_api').attr('poster', spinnerUrl);
                            if (!isDesktop) {
                                _this.videoPlayer.videoSettings = videoSettings;
                            }
                            _this.videoPlayer.videoPlayerOptions = videoPlayerOptions;
                            $('#div_video_html5_api').hide();

                            if (isDesktop || isMobile) {
                                _this.videoPlayer.dimensions(620, 620);
                            }
                            // assign the targeted videos to the source nodes
                            _this.videoPlayer.src(videoURL);
                            // reset the UI states
                            $('#div_video').removeClass('vjs-playing').addClass('vjs-paused');
                            // load the new sources
                            $('#div_video_html5_api').show();
                            _this.videoPlayer.load();
                        } else {
                            setTimeout(function() {
                                initializeVideo(videoSettings, videoPlayerOptions);
                            }, 300);
                        }
                    }
                    // Destroy youtube video if it exists in the dom
                    if (_this.youtubePlayer && _this.youtubePlayer.a) {
                        _this.youtubePlayer.destroy();
                    }
                    helpers.resetTwitchIframeSrc();

                    if (dataSource === 'youtube') {
                        setTimeout(function() {
                            if (this.currItem) {
                                helpers.initializeYoutubeVideo(this.currItem.data.media_id, videoSettings, videoPlayerOptions);
                            }
                        }.bind(this), 300);
                    } else if (dataSource === 'twitch') {
                        // Timeout is to make sure there's been some time for the iframe to load content
                        setTimeout(function() {
                            helpers.initializeTwitchPlayer(this.currItem.data.media_id, videoSettings);
                        }.bind(this), 300);
                    } else if (dataSource === 'tiktok') {
                        helpers.initializeTiktokPlayer(
                            helpers.getTikTokUrl(
                                this.currItem.data.platform_link,
                                this.currItem.data.media_id,
                                this.currItem.data.user_name
                            )
                        );
                    }
                },
                markupParse: function(template, values, item) {
                    // determine what the vote buttons should say for contest widgets
                    var voteTextToUse = item.data.userVoted ? 'widget.voted' : 'widget.vote';
                    var voteButtonText = helpers.getVoteButtonText(I18n.t(voteTextToUse), item.data.like_count);

                    if (item.data.products && item.data.products.length) {
                        // This still needs to be here separately because ONE part of the pricing layout
                        // sits outside the pricing template, so this covers that case

                        helpers.setDiscountAndStockTemplateVariables(item.data.products, displayOptions);
                    }

                    // Social links: Append image alt text to the existing `aria-label` attribute value here
                    // because the image alt text is not available in the template file
                    var socialLinks = ['Facebook', 'Twitter', 'Pinterest', 'Tumblr'];

                    for (var i = 0; i < socialLinks.length; i++) {
                        template.find('#' + socialLinks[i].toLowerCase() + '_share')
                            .attr('aria-label',
                            I18n.t('photo_item.social.open_window', { social: socialLinks[i] }) + ' - ' + item.alt);
                    }

                    template
                        .find('.vote_button')
                        .toggleClass('active', item.data.userVoted === true);

                    template
                        .find('.vote_button')
                        .text(voteButtonText);

                    template
                        .find('#cta_container, .review_holder, #' + deviceName + '_hotspot_holder')
                        .empty();

                    template.find('#frame_large').removeClass('has_cta');

                    if (!isDesktop && helpers.enableLightboxReviews) {
                        ReviewsHelper.setVisibility(item.data.selectedReviewInfo && item.data.selectedReviewInfo.active);
                    }

                    /**
                     * HOTSPOTS START
                     **/
                    if (displayOptions.hotspots) {
                        HotspotsHelper.setHotspots(displayOptions, currentAlbum, item.data);
                    }
                    /**
                     * HOTSPOTS END
                     **/

                    _api.onSetCtaLinks(template, item.data, currentAlbum, displayOptions);

                    if (!isDesktop) {
                        template.find('#middle_block').removeClass('simple_cta');
                    } else {
                        if (!helpers.isAnonymousInstagram) {
                            var hasUndefinedUserInfo = _.isFalsy(item.data.user_name);
                            template
                                .find('#user_info_holder')
                                .children()
                                .toggle(!hasUndefinedUserInfo);
                        }
                    }

                    helpers.uploaderAdditionalFields(item, template);

                    if (!isDesktop) {
                        if (isMobile) {
                            // adding a class called 'ios_video' based on device + content
                            // type detection so we can apply specific styles in
                            // CSS to videos on iOS version of lightbox
                            var iOS = /iPad|iPhone|iPod/.test(navigator.platform);
                            var iosVideo = iOS && item.data.content_type === 'video';
                            template.toggleClass('ios_video', iosVideo);
                        }
                        // In cases window.localStorage is null (Firefox mobile)
                        if (window.localStorage) {
                            // Here we are saving the current/last viewed photo in the widget to local storage so if the widget is loaded from
                            // a persisted resource (such as the back/forward button) reload the lightbox with the correct photo incase the incorrect
                            // one shows up due to browser cache.
                            var lastViewedPixleeAlbumPhoto = window.localStorage.getItem('pixleeAlbumPhotoId');

                            // This needs to run AFTER pixleePersisted is executed OR if we don't have an pixleeAlbumPhotoId already saved
                            if (checkedPixleePersisted || _.isFalsy(lastViewedPixleeAlbumPhoto)) {
                                window.localStorage.setItem('pixleeAlbumPhotoId', this.currItem.data.album_photo_id);
                            }
                        }
                    }
                },
                elementParse: function(item) {
                    item = helpers.onElementParse(item, currentAlbum, spinnerUrl);

                    if (isDesktop) {
                        if (item.data.subtype !== 'instagram_story') {
                            item.data.story_style = 'display:none';
                        }
                    } else {
                        var dataSource = item.data.source;

                        if (item.data.content_type === 'video' && !_.contains(['youtube', 'twitch'], dataSource)) {
                            $('#pixlee_video_html5_api').attr('poster', spinnerUrl);
                            item.data.hideOnImage_thumbnail = item.data.thumbnail_url;
                        }
                    }

                    // lightbox images/video are focusable so we need alt-text to describe the image
                    item.alt = decodeUtf8(item.data.alt_text || item.data.photo_title);

                    if (isMobile) {

                        // the "playsInline" option lets us set our video players to play the
                        // videos inline in lightbox versus fullscreen on iOS
                        var videoOptions = gon.display_options.videoOptions || {};

                        if (videoOptions.playsInline) {
                            item.data.lightboxVideo_playsinline = true;
                        }
                    }

                    return item;
                }
            }
        };


        if (!isDesktop) {
            mfpOptions.gallery.navigateByImgClick = false;
            mfpOptions.callbacks.afterChange = function() {
                if (helpers.enableCarousel) {
                    PixleeCarousel.initialize();
                }
            };
        } else {
            mfpOptions.callbacks.afterChange = function() {
                helpers.applyStyleBySource(this.currItem.data.source);
            };
        }
        if (isMobile) {
            mfpOptions.callbacks.buildControls = function() {
                if (helpers.lightboxVersion === 'v2' && this.arrowLeft && this.arrowRight) {
                    this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
                }
            };
            mfpOptions.callbacks.afterChange = function() {
                if (helpers.enableCarousel) {
                    PixleeCarousel.initialize();
                }
                if (this.currItem.data.source === 'tiktok') {
                    helpers.applyMobileTiktokStyles();
                } else {
                    helpers.removeMobileTiktokStyles();
                }
            };
        }
        if (isTablet) {
            mfpOptions.fixedContentPos = true;
            mfpOptions.callbacks.afterChange = function() {
                if (helpers.enableCarousel) {
                    PixleeCarousel.initialize();
                }
                if (this.currItem.data.source === 'tiktok') {
                    helpers.applyTabletTiktokStyles();
                } else {
                    helpers.removeTabletTiktokStyles();
                }
            };
        }

        helpers.setMagnificPopup($.magnificPopup.open(mfpOptions,
            index || 0
        ));
    }

    function receiveMessage(event) {
        var eventData;
        if (event.data) {
            try {
                eventData = JSON.parse(event.data);
            } catch (error) {
                // Some other way of sending data, ignore
                return;
            }
        } else {
            return;
        }
        if (eventData.name && eventData.name === 'pixlee:open:lightbox') {
            var dataObj = eventData.data;
            var variables = JSON.parse(dataObj.variables);
            var pageSize = variables.perPage;
            var currentAlbum = dataObj.current_album;
            var displayOptions = dataObj.display_options;
            var indexToOpen = helpers.getPhotoModelIndex(dataObj.indexToOpen, displayOptions);

            //this is some awful global variable, please someone fix this when they have time
            data = JSON.parse(dataObj.modelData);

            gon.sortType = variables.sortType;
            gon.widget = variables.widget;
            gon.usingKeyboard = dataObj.usingKeyboard;

            openLightbox(indexToOpen, currentAlbum, displayOptions, pageSize);
        } else if (eventData.name && eventData.name === 'pixlee:vote:loaded') {
            //If the lightbox was opened as deep link set the vote as a message from the widget
            //Ask magnific popup to refresh
            if (_.isTruthy(gon.lightbox_album_photo) && gon.lightbox_album_photo.length > 0) {
                for (var i = data.length - 1; i >= 0; i--) {
                    if (eventData.data.pixlee_votes.indexOf(data[i].album_id + '_' + data[i].album_photo_id) !== -1) {
                        data[i].userVoted = true;
                        helpers.magnificPopup.items[i].data = data[i];
                        $.magnificPopup.instance.updateItemHTML();
                    }
                }
            }
        }
    }

    if (_.isTruthy(gon.lightbox_album_photo) && gon.lightbox_album_photo.length > 0) {
        data = [gon.lightbox_album_photo[0].album_photo];
        data[0].submitterFormatted = helpers.submitterFormatted(data[0]);
        data[0].submitterHref = helpers.submitterHref(data[0]);
        data[0].actionLinkFormatted = helpers.actionLinkFormatted(data[0]);
        data[0].captionFormatted = helpers.captionFormatted(data[0]);
        data[0].actionLinkTextFormatted = helpers.actionLinkTextFormatted(data[0]);
        data[0].actionLinkTitleFormatted = helpers.actionLinkTitleFormatted(data[0]);
        data[0].actionLinkPhotoFormatted = helpers.actionLinkPhotoFormatted(data[0]);
        data[0].videoURL = helpers.videoURL(data[0]);
        data[0].posterUrl = isDesktop ? spinnerUrl : helpers.posterUrl(data[0]);
        data[0].products = gon.products;
        openLightbox();
    } else {
        var msg = {
            name: 'pixlee:remove:url:param',
            type: 'action',
            source: 'lightbox',
            destination: 'parent',
            data: {}
        };

        window.parent.postMessage(JSON.stringify(msg), '*');
    }
    window.addEventListener('message', receiveMessage, false);

    window.onload = function() {
        window.parent.postMessage(JSON.stringify({
            ready: true
        }), '*');
    };

});
